<template>
	<div class="menuConfiguration mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">菜单配置</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">菜单配置</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新增模块"></div>
			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" style="width: 100%" height="580" row-key="permissionsModelId" lazy
							:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
							<el-table-column show-overflow-tooltip prop="permissionsModelName" label="菜单名称">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="permissionsModelId" label="编号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="path" label="路径">
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope" v-if="!scope.row.parentPermissionsModelId">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">编辑</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<div class="dialogBox">
				<el-form :model="itemObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="模块名称" prop="permissionsModelName">
								<div class="myinputBox">
									<el-input clearable v-model="itemObj.permissionsModelName" placeholder="请输入模块名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div class="titleBox">子菜单</div>
				<div class="parameterBox disCenter">
					<div class="flexBox disStart">
						<div class="itemBox disBetween" v-for="(item,inx) in itemObj.children" :key="inx">
							<div class="disBetween menuItem">
								<div class="numItem  disStart">
									<div class="lableBox">菜单名称：</div>
									<div class="inputBox">
										<el-input v-model="item.permissionsModelName" placeholder="请输入菜单名称"></el-input>
									</div>
								</div>
								<div class="numItem numItem1 disStart">
									<div class="lableBox">菜单路径：</div>
									<div class="inputBox">
										<el-input v-model="item.path" placeholder="请输入菜单路径"></el-input>
									</div>
								</div>
							</div>
							<div class="btnBox disStart">
								<span class="delIcon" @click="btnClick(item,inx,1)"></span>
								<span class="addIcon" v-if="inx==itemObj.children.length-1"
									@click="btnClick(item,inx,2)"></span>
							</div>
						</div>
					</div>

				</div>

			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="toSave('ruleForm3')" v-preventReClick="3000">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		menuData
	} from "@/assets/js/data.js"
	export default {
		name: "menuConfiguration",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				dialogVisible: false,
				dialogTitle: "新增菜单",
				NOfalse: false,
				tableData: [],
				loading: false,
				itemObj: {
					permissionsModelCode: "",
					permissionsModelName: "",
					path: "",
					children: []
				},
				rules: {
					permissionsModelName: [{
						required: true,
						message: '请输入模块名称',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			itemClick(item, n) { //1编辑2删除5新增
				let that = this
				if (n == 5) {
					this.$set(this, "itemObj", {
						permissionsModelCode: "",
						permissionsModelName: "",
						path: "",
						children: [{
							permissionsModelCode: "",
							permissionsModelName: "",
							path: "",
						}]
					})
					this.dialogTitle = "新增菜单"
					this.dialogVisible = true

				}else if (n == 1) {
					this.$set(this, "itemObj", item)
					this.dialogTitle = "编辑菜单"
					this.dialogVisible = true
				}else if (n == 2) {
					this.$confirm('是否确认删除该模块?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deletePermissionsModel({
							permissionsModelId: item.permissionsModelId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
							} 
						})
					
					}).catch(() => {
					
					});
				}
			},
			getData(n) {
				this.loading = true
				this.$api.listPermissionsModel({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj)
						this.loading = false
					}
				})
			},
			// 按钮保存 新增/编辑
			toSave(formName) {
				let that = this
				
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.itemObj.children.length <= 0 || !this.itemObj.children) {
							this.$message({
								type: 'warning',
								message: '最少保留一个子菜单!'
							});
							return false
						} else {
							for (let k of this.itemObj.children) {
								if (k.permissionsModelName == '') {
									this.$message({
										type: 'warning',
										message: '请输入菜单名称!'
									});
								}
								if (k.path == '') {
									this.$message({
										type: 'warning',
										message: '请输入菜单路径!'
									});
								}
							}
						}
						if (this.dialogTitle == "新增菜单") {
							this.addPermissionsModel()
						} else {
							this.updatePermissionsModel()
						}
					} else {
						return false;
					}
				});
			},
			addPermissionsModel() {
				
				this.$api.addPermissionsModel(this.itemObj).then((res)=>{
					if (res.returnCode == 200) {
						this.$message({
							type: 'success',
							message: '新增成功!'
						});
						this.dialogVisible = false
						setTimeout(() => {
							this.getData()
						}, 500)
					}
				})
			},
			updatePermissionsModel() {
				this.$api.updatePermissionsModel(this.itemObj).then((res)=>{
					if (res.returnCode == 200) {
						this.$message({
							type: 'success',
							message: '编辑成功!'
						});
						this.dialogVisible = false
						setTimeout(() => {
							this.getData()
						}, 500)
					}
				})
			},
			btnClick(item, inx, n) {
				let that = this
				if (n == 1) {
					if (this.itemObj.children.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保留一个子菜单!'
						});
						return false
					}
					this.itemObj.children.splice(inx, 1)
				} else {
					this.itemObj.children.push({
						permissionsModelCode: "",
						permissionsModelName: "",
						path: "",
					})
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./menuConfiguration.scss";
</style>